<script setup lang="ts">
    import { computed, onMounted, ref } from 'vue';
    import { getDocumentationDocumentLink } from '@/shared/helpers/routing';
    import { shortDate } from '@/formatters';
    import { Document, getTopicDocuments } from './data';
    import DocumentationBrowserContainer from './DocumentationBrowserContainer.vue';

    const documents = ref<Document[]>([]);
    const loading = ref<boolean>(false);

    const props = defineProps<{
        identity: string;
    }>();

    const topicName = computed(() => documents.value.length > 0 ? documents.value[0].topicName : '');

    onMounted(async () => {
        try {
            loading.value = true;
            documents.value = await getTopicDocuments(props.identity);
        } finally {
            loading.value = false;
        }
    });

</script>

<template>
    <documentation-browser-container>
        <div class="block title is-5">
            <router-link :to="{ name: 'DocumentationBrowser' }">
                Topics
            </router-link>
            <span class="has-text-grey"> / </span>{{ topicName }}
        </div>
        <b-table
            :data="documents"
            :loading="loading"
            striped>
            <b-table-column
                v-slot="tableProps"
                field="name"
                label="Name"
                sortable>
                <b-icon
                    icon="file-document"
                    class="mr-4" />
                <router-link :to="getDocumentationDocumentLink(tableProps.row.identity)">
                    <b>
                        {{ tableProps.row.name }}
                    </b>
                </router-link>
            </b-table-column>
            <b-table-column
                v-slot="tableProps"
                field="description"
                label="Description"
                sortable>
                {{ tableProps.row.description }}
            </b-table-column>
            <b-table-column
                v-slot="tableProps"
                field="tags"
                label="Tags"
                sortable>
                {{ tableProps.row.tags }}
            </b-table-column>
            <b-table-column
                v-slot="tableProps"
                field="dateCreated"
                label="Created"
                sortable>
                {{ shortDate(tableProps.row.dateCreated) }}
            </b-table-column>
            <b-table-column
                v-slot="tableProps"
                field="dateUpdated"
                label="Updated"
                sortable>
                {{ shortDate(tableProps.row.dateUpdated) }}
            </b-table-column>
        </b-table>
    </documentation-browser-container>
</template>
